import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const createWorkflowResponse: OpalApi<
  'CreateWorkflowResponseV3',
  201
> = async ({
  params,
  requestBody,
}: Parameters<OpalApi<'CreateWorkflowResponseV3', 201>>[0] = {}) => {
  const url = new URL('/v3/workflow_responses', window.location.origin)
  url.search = queryString(params?.query)
  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
